import api from './api';
import { User } from '../types/auth';
import { Position, Department } from '../types/user';

export type UpdateUserPayload = Partial<User> & {
    password?: string;
    password_confirmation?: string;
};

export const getUsers = () => {
    return api.get<User[]>('/users');
};

export const createUser = (userData: Partial<User>) => {
    return api.post<User>('/users', userData);
};

export const updateUser = (id: number, userData: UpdateUserPayload) => {
    return api.put<User>(`/users/${id}`, userData);
};

export const deleteUser = (id: number) => {
    return api.delete(`/users/${id}`);
};

export const getPositions = () => {
    return api.get<Position[]>('/positions');
};

export const createPosition = (data: { name: string; department_id: number }) => {
    return api.post<Position>('/positions', data);
};

export const updatePosition = (id: number, data: { name: string; department_id: number }) => {
    return api.put<Position>(`/positions/${id}`, data);
};

export const deletePosition = (id: number) => {
    return api.delete(`/positions/${id}`);
};

export const getDepartments = () => {
    return api.get<Department[]>('/departments');
};

export const createDepartment = (data: { name: string }) => {
    return api.post<Department>('/departments', data);
};

export const updateDepartment = (id: number, data: { name: string }) => {
    return api.put<Department>(`/departments/${id}`, data);
};

export const deleteDepartment = (id: number) => {
    return api.delete(`/departments/${id}`);
};

export default getUsers;